export default __webpack_public_path__ + "static/media/anchor.e82b1a91.jpg";